module.exports = __webpack_public_path__ + "img/roblox-input.52419e7f.svg";